import React from "react";

import { Link, navigate } from "gatsby-plugin-intl";
const helpers = require("../../helpers");

import Image from "../molecules/image";

import "../../scss/molecules/_card.scss";

class Card extends React.Component {
  render() {
    const media = this.props.media ? (
      <div className="card-media">
        <Image {...this.props.media} aspectRatio="2x1" />
      </div>
    ) : (
      ""
    );

    return (
      <div
        className={"card"}
        onClick={() => {
          navigate(this.props.to);
        }}
      >
        <Link to={helpers.getTrailedUrl(this.props.to)}>
          {media}
          <div className="card-body">
            <p className="card-title">{this.props.title}</p>
            <p className="card-description">{this.props.description}</p>
          </div>
        </Link>
      </div>
    );
  }
}

export default Card;
